import { ReactComponent as CheckmarkFromFile } from '@/assets/images/svg/glyphs/checkmark-thick.svg';
import type { FC, SVGProps } from 'react';

/**
 * Each glyph’s source file lives under `src/assets/…`. At build time, Next.js runs those `.svg`
 * files through SVGR (`@svgr/webpack`, wired in `src/next-config/webpack.js`) and exposes them as
 * `ReactComponent`. That’s what we want to render whenever it’s available.
 *
 * Storybook is wired through `@storybook/nextjs`, which normally reuses that same webpack setup.
 * In practice, webpack merges and version bumps don’t always match the main app exactly. When SVGR
 * doesn’t run for a given bundle, `ReactComponent` can be `undefined`. Anything that wraps the
 * icon at module load — for example `styled(SomeGlyph)` — then throws an error before your story renders.
 *
 * The inline SVG below mirrors the asset so icons still show up in Storybook (and any other
 * environment where the loader chain differs) instead of taking down the module graph.
 */
const FallbackCheckmark: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" {...props}>
    <path
      d="M2 4.70898L4.88144 7.59043L10.3296 2.14229"
      stroke="currentColor"
      strokeWidth={2.72}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckmarkThickGlyph: FC<SVGProps<SVGSVGElement>> =
  typeof CheckmarkFromFile === 'function' ? CheckmarkFromFile : FallbackCheckmark;
